import React from 'react';
import './FormBanner.css';

/**
 * Inline dismissible banner for form validation, success, and info messages.
 * @param {{ message?: string, type?: 'error'|'success'|'info', onDismiss?: () => void, className?: string }} props
 */
export default function FormBanner({ message, type = 'error', onDismiss, className = '' }) {
  if (!message) return null;

  return (
    <div className={`form-banner form-banner--${type} ${className}`.trim()} role="alert">
      <span className="form-banner__text">{message}</span>
      {onDismiss && (
        <button
          type="button"
          className="form-banner__dismiss"
          onClick={onDismiss}
          aria-label="Dismiss"
        >
          ✕
        </button>
      )}
    </div>
  );
}
